import { render, staticRenderFns } from "./Promo2018.vue?vue&type=template&id=c9cfdb5e&scoped=true&"
import script from "./Promo2018.vue?vue&type=script&lang=js&"
export * from "./Promo2018.vue?vue&type=script&lang=js&"
import style0 from "./Promo2018.vue?vue&type=style&index=0&id=c9cfdb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cfdb5e",
  null
  
)

export default component.exports